import * as React from 'react';
const styles = require('./ResponsiveContainer.pcss');

/*--- Interfaces ---*/

interface IState {
    width: number;
}

interface IProps {
    breakpoint?: number;
}

/*--- Components ---*/

export class ResponsiveContainer extends React.Component<IProps, IState>{

    /**
     *  Handles the desktop and mobile versions of a table,
     *  or simply one version if only one is passed as a child.
     * 
     *  The ordering needs to be desktop version first, then mobile version
     */

    constructor(props){
        super(props);

        this.updateLocalState = this.updateLocalState.bind(this);
    }

    updateLocalState() {
        this.setState({ width: window.innerWidth });
    }

    componentWillMount() {
        this.updateLocalState();
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateLocalState);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateLocalState);
    }

    render() {

        if (Array.isArray(this.props.children) && this.props.breakpoint) {
            return this.state.width > this.props.breakpoint ? 
                <div className={styles.tableList}>{this.props.children[0]}</div> :
                <div className={styles.tableList}>{this.props.children[1]}</div>;

        }else{
            return <div className={styles.tableList}>{this.props.children}</div>;
        }

    }
}


// WEBPACK FOOTER //
// ./src/client/components/ResponsiveContainer/ResponsiveContainer.tsx